module.exports = __webpack_public_path__ + "static/media/video_placeholder.75e03ff0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video_placeholder.jpg
// module id = 56
// module chunks = 0